import { render, staticRenderFns } from "./DescuentoGeneralComponent.vue?vue&type=template&id=7f6e6e53"
import script from "./DescuentoGeneralComponent.vue?vue&type=script&lang=js"
export * from "./DescuentoGeneralComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports